import React from 'react'
import injectJss from 'react-jss'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'

const style = {
    imgPreview: {
        maxWidth: ({ maxWidth }) => (maxWidth ? maxWidth + 'px' : '100%'),
        maxHeight: ({ maxHeight }) => (maxHeight ? maxHeight + 'px' : 'initial'),
        display: 'flex',
        margin: 'auto',
    },
}

const PhotoPlayer = ({ src, classes }) => <img src={src} className={classes.imgPreview} />

PhotoPlayer.propTypes = {
    src: PropTypes.string,
    maxWidth: PropTypes.number,
    maxHeight: PropTypes.number,
}

export default compose(injectJss(style))(PhotoPlayer)
